import { render, staticRenderFns } from "./IconIncomingRequest.vue?vue&type=template&id=12706b52&"
import script from "./IconIncomingRequest.vue?vue&type=script&lang=js&"
export * from "./IconIncomingRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports